import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from '~shared/services/page.service';
import { BuyerAccountService } from '~core/modules/buyer-account';

@Component({
  selector: 'app-fd-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
})
export class SSOComponent implements OnInit {
  constructor(
    private router: Router,
    private pageService: PageService,
    private buyerAccountService: BuyerAccountService,
    private activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.buyerAccountService.loginToSSO(this.activatedRoute.snapshot.queryParamMap);
  }
}
